export { default } from '@/features/shiftCloseouts/pages/CashTransactionsPage'
